import { setSidebarCollapsed } from "../slices/ui";

export const toggleSidebar = () => (dispatch, getState) => {
  const { isSidebarCollapsed } = getState().ui;
  dispatch(setSidebarCollapsed(!isSidebarCollapsed));
};

export const setSidebarState = (isCollapsed) => (dispatch) => {
  dispatch(setSidebarCollapsed(isCollapsed));
};
